<template>
  <Card noBorder>
    <SectionHeader
      title="Password Settings"
    >
      {{ $options.instructions }}
      {{ $options.linkAction }}
      <Link
        :href="$options.kbLink"
        isExternal
        target="_blank"
        text="Password Settings in the JumpCloud Admin Portal"
      />
    </SectionHeader>
    <template v-slot:body>
      <FieldsPasswordMinLength
        v-model="item"
        :class="$style.passwordSection"
      />
      <FieldsPasswordComplexity
        v-model="item"
        :class="$style.passwordSection"
      />
      <FieldsPasswordOriginality
        v-model="item"
        :class="$style.passwordSection"
      />
      <FieldsPasswordAging
        :id="$options.passwordAgingConst"
        v-model="item"
        :class="$style.passwordSection"
      />
      <FieldsPasswordLockout
        v-model="item"
        :class="$style.passwordSection"
      />
    </template>
  </Card>
</template>

<script>

import { Card, Link } from '@jumpcloud/ui-components';
import { passwordAgingConst } from 'client/settings/Security/SecuritySettingsConstants';
import FieldsPasswordAging from 'client/settings/Security/FieldsPasswordAging.vue';
import FieldsPasswordComplexity from 'client/settings/Security/FieldsPasswordComplexity.vue';
import FieldsPasswordLockout from 'client/settings/Security/FieldsPasswordLockout.vue';
import FieldsPasswordMinLength from 'client/settings/Security/FieldsPasswordMinLength.vue';
import FieldsPasswordOriginality from 'client/settings/Security/FieldsPasswordOriginality.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import SectionHeader from 'client/settings/components/SectionHeader.vue';

const instructions = 'Configure the global settings around users password requirements.';

export default {
  name: 'SectionPassword',

  components: {
    Card,
    FieldsPasswordAging,
    FieldsPasswordComplexity,
    FieldsPasswordLockout,
    FieldsPasswordMinLength,
    FieldsPasswordOriginality,
    SectionHeader,
    Link,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    item: {
      get() {
        return this.value.passwordPolicy || {};
      },
      set(newValue) {
        this.$emit('input', {
          ...this.value,
          passwordPolicy: newValue,
        });
      },
    },
  },

  instructions,
  passwordAgingConst,
  kbLink: KbArticleUrls.securitySettingsPassword,
  linkAction: 'See',
};
</script>

<style module>
  .passwordSection {
    margin-bottom: 3rem;
  }
</style>
